
webpack.register(
    'blocks/photo-gallery/photo-gallery',
    function() {
        return import('blocks/photo-gallery/photo-gallery');
    },
    true
);

webpack.register(
    'components/tag-based-related-content-slider/tag-based-related-content-slider',
    function() {
        return import('components/tag-based-related-content-slider/tag-based-related-content-slider');
    },
    true
);